export default __webpack_public_path__ + "static/media/figma.72fbc535.png";